import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID } from 'utils/types';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import ServiceCatalogContainer from './home/ServiceCatalogContainer';
import ConnectionContainer from './connectionProfile/ConnectionContainer';
import ConnectionSchedulerContainer from './appointments/connection/ConnectionSchedulerContainer';
import ServiceSchedulerContainer from './appointments/service/ServiceSchedulerContainer';
import ServiceContainer from './serviceProfile/ServiceContainer';
import SearchContainer from './search/SearchContainer';
import NotFound from 'common/NotFound';
import queryString from 'query-string';
import { hot } from 'react-hot-loader';

import * as routes from './routes';

class App extends React.Component {

  constructor() {
    super();
    // Global app state
    this.state = {
      services: [],
      connections: [],
      selectedService: null,
      searchResults: { services: [], connections: [] },
      searchQuery: ''
    };
  }

  renderServiceCatalogContainer() {
    return (
      <ServiceCatalogContainer
        isStudent={this.props.isStudent}
        isStaff={this.props.isStaff}
        isServiceMember={this.props.isServiceMember}
        canSeeServices={this.props.canSeeServices}
        canSeeSuccessNetwork={this.props.canSeeSuccessNetwork}
        canSeeStudentServices={this.props.canSeeStudentServices}
        canMakeAppointment={this.props.canMakeAppointment}
        studentAnnouncementEnabled={this.props.studentAnnouncementEnabled}
        hasConnectLicense={this.props.hasConnectLicense}
        services={this.state.services}
        onServicesFetched={services => this.setState({services})}
        connections={this.state.connections}
        onConnectionsFetched={connections => this.setState({connections})}
        searchResults={this.state.searchResults}
        onResultsFetched={searchResults => this.setState({searchResults})}
        searchQuery={this.state.searchQuery}
        onSearchChange={searchQuery => this.setState({searchQuery})}
        responsiveKioskEnabled={this.props.responsiveKioskEnabled}
        virtualCheckInEnabled={this.props.virtualCheckInEnabled}
      />
    );
  }

  renderServiceContainer({match}) {
    const { id } = match.params;

    // If we have already fetched the service, find it
    const fetchedService = this.state.services.find(service => String(service.id) === id);
    // Pass as prop the service if fetched, or find it in the array to save time
    const service = typeof fetchedService !== "undefined" ? fetchedService : this.state.selectedService;
    return (
      <ServiceContainer
        service={service}
        onServiceFetched={selectedService => this.setState({selectedService})}
        isServiceMember={this.props.isServiceMember}
        isStudent={this.props.isStudent}
        isStaff={this.props.isStaff}
        canSeeStudentServices={this.props.canSeeStudentServices}
        canMakeAppointment={this.props.canMakeAppointment}
        hasConnectLicense={this.props.hasConnectLicense}
        id={id}
      />
    );
  }

  renderSearchContainer() {
    const { q } = queryString.parse(location.hash.split("#/search")[1]);
    return (
      <SearchContainer
        results={this.state.searchResults}
        onResultsFetched={searchResults => this.setState({searchResults})}
        query={q === null || typeof q === 'undefined' ? '' : q}
        resetQuery={() => this.setState({searchQuery: ''})}
        isServiceMember={this.props.isServiceMember}
        isStudent={this.props.isStudent}
      />
    );
  }

  renderServiceScheduler({match, location}) {
    const parsedParams = queryString.parse(location.search);
    const restrictToSectionId = parsedParams ? parsedParams.sectionId : null;
    return <ServiceSchedulerContainer {...this.props} id={match.params.id} restrictToSectionId={restrictToSectionId} />
  }

  render() {
    return (
      <Router>
        <Switch>
          <Route
            exact from="/studentFolder"
            render={({history}) => {
              history.goBack();
              return null;
            }}
          />
          <Route
            exact path="/"
            render={this.renderServiceCatalogContainer.bind(this)}
          />
          <Route
            exact path={routes.toStaffUser()}
            render={({ match }) => <ConnectionContainer {...this.props} id={match.params.id} />}
          />
          <Route
            exact path={routes.toScheduleStaffUserAppointment()}
            render={ ({ match }) =>
                <ConnectionSchedulerContainer id={match.params.id}
                                              partyId={this.props.partyId}
                                              userTimeZone={this.props.userTimeZone} />
            }
          />
          <Route
            exact path={routes.toScheduleStaffUserAppointmentForService()}
            render={ ({ match }) =>
                <ConnectionSchedulerContainer id={match.params.id}
                                              partyId={this.props.partyId}
                                              serviceId={match.params.serviceId}
                                              userTimeZone={this.props.userTimeZone} />
            }
          />
          <Route
            exact path={routes.toStaffUserInService()}
            render={({ match }) => <ConnectionContainer {...this.props} serviceId={match.params.serviceId} id={match.params.id} />}
          />
          <Route
            exact path="/service/:id"
            render={this.renderServiceContainer.bind(this)}
          />
          <Route
            path="/service/:id/schedule"
            render={this.renderServiceScheduler.bind(this)}
          />
          <Route
            path="/search"
            render={this.renderSearchContainer.bind(this)}
          />
          <Route component={NotFound} />
        </Switch>
      </Router>
    );
  }
}

App.propTypes = {
  isStudent: PropTypes.bool.isRequired,
  isStaff: PropTypes.bool.isRequired,
  isServiceMember: PropTypes.bool.isRequired,
  canSeeSuccessNetwork: PropTypes.bool.isRequired,
  canSeeServices: PropTypes.bool.isRequired,
  canSeeStudentServices: PropTypes.bool.isRequired,
  canMakeAppointment: PropTypes.bool.isRequired,
  studentAnnouncementEnabled: PropTypes.bool.isRequired,
  hasConnectLicense: PropTypes.bool.isRequired,
  partyId: SFEntityID.isRequired,
  userTimeZone: PropTypes.string.isRequired,
  responsiveKioskEnabled: PropTypes.bool,
  virtualCheckInEnabled: PropTypes.bool,
};

export default hot(module)(App);
